<template>
    <StepTemplate :activeStepNr="this.activeStepNr"
                  :myStepNr="this.myStepNr"
                  :value="value"

    >
        <template slot="slide-form">
            <form data-vv-scope="xxx" @click.alt="testFillForm()">
                <!--============================================================================================================-->
                <!--
                <v-layout row>
                    <v-flex xs11 class="mt-2"><h5>{{this.label}}</h5></v-flex>
                </v-layout>
                -->
                <!--============================================================================================================ -->
                <v-layout row class="section_header">
                    <v-flex xs11 class="mt-2 blue-grey lighten-4"><h6>Antrag-Daten</h6></v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <v-flex xs12 style=" font-size: 0.9em;">
                        <Anzeigepflicht-Block><!-- TextBlock mit Hinweis zur Pflicht alle Daten korrekt anzugeben--></Anzeigepflicht-Block>
                    </v-flex>
                </v-layout>

                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <Rechner-hint-col>
                        xxxxx
                    </Rechner-hint-col>

                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.vertrag_beginn" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <Rechner-hint-col>
                        Hier können Sie wählen, ob der Versicherungs-Beitrag einmal im Jahr, halbjährlich oder
                        vierteljährlich gezahlt werden soll.
                        <br>Eine monatliche Zahlweise ist nicht möglich.
                    </Rechner-hint-col>
                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.vertrag_zahlungsweise" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row class="section_header">
                    <v-flex xs11 class="mt-2 blue-grey lighten-4"><h6>Standort der Anlage</h6></v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <Rechner-hint-col>
                        xxx
                    </Rechner-hint-col>
                    <v-flex xs7>
                        <Rechner-field-col :fielddef="fieldDefs.heiz_lage_strasse" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                    <v-flex xs3>
                        <Rechner-field-col :fielddef="fieldDefs.heiz_lage_hausnummer" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>

                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <Rechner-hint-col>
                        xxx
                    </Rechner-hint-col>
                    <v-flex xs4>
                        <Rechner-field-col :fielddef="fieldDefs.heiz_lage_plz" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                    <v-flex xs6>
                        <Rechner-field-col :fielddef="fieldDefs.heiz_lage_ort" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row class="section_header">
                    <v-flex xs11 class="mt-2 blue-grey lighten-4"><h6>Daten zur Anlage</h6></v-flex>
                </v-layout>
              <!------------------------------------------------------------------------------------------------------------>
              <v-layout row>
                <Rechner-hint-col>
                  xxxxx
                </Rechner-hint-col>
                <v-flex xs10>
                  <Rechner-field-col :fielddef="fieldDefs.heiz_heizung_typ" v-model="value.fieldValues"
                                     :$v="$v"></Rechner-field-col>
                </v-flex>
              </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <Rechner-hint-col>
                        xxxxx
                    </Rechner-hint-col>

                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.heiz_heizung_hersteller" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                </v-layout>

                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <Rechner-hint-col>
                        xxxxxxxxxx
                    </Rechner-hint-col>
                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.heiz_datum_inbetrieb" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <Rechner-hint-col>
                        xxxxx
                    </Rechner-hint-col>
                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.heiz_kaufpreis" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <!--
                <v-layout row>
                    <Rechner-hint-col>
                        Bitte laden Sie eine Kopie des Kaufbeleges als Bild oder pdf hoch. (max. 1MG groß)
                    </Rechner-hint-col>
                    <v-flex xs6>
                        <Rechner-field-col :fielddef="fieldDefs.heizung_kaufvertrag_filename" v-model="value.fieldValues"
                                           :$v="$v" :disabled="true"></Rechner-field-col>
                    </v-flex>
                    <v-flex xs4>
                        <form enctype="multipart/form-data" novalidate>
                            <v-btn :disabled="upload_isSaving" @click="openFileBrowser()"
                                   style="position: relative;left:-8px; z-index: 1 ; width: 100%">
                                Datei hochladen
                            </v-btn>
                            <input ref="heizungStep1_Input_fileUpload"
                                   style="position: absolute;height: 1px;width: 1px;display: contents;opacity:0.0001;"
                                   type="file"
                                   multiple="false"
                                   :name="uploadFieldName"
                                   :disabled="upload_isSaving"
                                   @change="upload_filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
                                   accept="image/*,application/pdf"
                                   class="input-file">

                        </form>
                    </v-flex>
                </v-layout>
                -->

                <!--============================================================================================================-->
            </form>

        </template>
    </StepTemplate>
</template>
<!-- _____________________________________________________________________________________________________________________________________________________________ -->
<!-- ############################################################################################################################################################# -->
<script>
    import slideMixin from '../stepMixin'
    import _ from 'lodash'
    //import VueUploadComponent from 'vue-upload-component'
    //import VBtn from 'vuetify/src/components/VBtn/VBtn'
    //import {mapState} from 'vuex'

    /*
    const STATUS_INITIAL = 0
    const STATUS_SAVING = 1
    const STATUS_SUCCESS = 2
    const STATUS_FAILED = 3
*/
    export default {
        //========================================================================================================
        name: 'Step_heizung_I',
        label: 'heizung Daten',
        label2: 'heizung<br>Daten',


        fieldKeys: [
            'heiz_lage_strasse',
            'heiz_lage_hausnummer',
            'heiz_lage_plz',
            'heiz_lage_ort',
            'heiz_kaufpreis',
            'heiz_heizung_hersteller',
            'heiz_heizung_typ',
            'heiz_datum_inbetrieb',

            'vertrag_zahlungsweise',
            'vertrag_beginn',
        ],
        //========================================================================================================
        data: function () {
            //fieldDefs wird in StepMixin mit den Werten aus der Datenbank belegt,
            //an dieser Stelle können diese Werte überschrieben werden.
            // Vue merged von alleine die Werte aus 'stepMixin' und denen aus 'fieldDefs_OVERRIDE'
            var fieldDefs_OVERRIDE = {}


            /*
                  var options = this.$store.state.rechnerConfig.fieldDefs.heizung_tarif_modell.selectOptions
                  console.log("XXXXXXXXXXXXXXXXXXXXXX", options)
                  var optionsStandard = []
                  var optionsheizungKrieg = []
                  for (index in options) {
                    var modelNr = options[index].value
                    if (modelNr === 4 || modelNr === 5 || modelNr === 7) {
                      optionsheizungKrieg.push(options[index])
                    }
                    if (modelNr === 1 || modelNr === 2 || modelNr === 3|| modelNr === 4) {
                      optionsStandard.push(options[index])
                    }

                  }

                  if (this.$route.params.vermittlerNr === "1234") {
                    this.$store.state.rechnerConfig.fieldDefs.heizung_tarif_modell.selectOptions = optionsheizungKrieg
                  } else {
                    this.$store.state.rechnerConfig.fieldDefs.heizung_tarif_modell.selectOptions = optionsStandard
                  }

            */
            return {
                fieldDefs: fieldDefs_OVERRIDE,
             //   disabled_heizungAnzahl: false,
             //   disabled_tarif_modell: true,
             //   upload_errorText: '',
             //   upload_progress: 0,
             //   uploadedFiles: [],
             //   uploadError: null,
             //   uploadStatus: null,
             //   uploadFieldName: 'photos',
             //   showInfoModal: false,
             //   upLoadSpeed: 75000,
             //   upload_fileSize: 10000,
             //   stepper: 0,
             //   upload_progressIntervallTimer: null,

            }
        }, //========================================================================================================
        mixins: [slideMixin],
        //========================================================================================================
        computed: {
            /*
            upload_isInitial() {
                return this.uploadStatus === STATUS_INITIAL
            },
            upload_isSaving() {
                return this.uploadStatus === STATUS_SAVING
            },
            upload_isSuccess() {
                return this.uploadStatus === STATUS_SUCCESS
            },
            upload_isFailed() {
                return this.uploadStatus === STATUS_FAILED
            }
            */
        },  //===========================================================================================================
        methods: {
            /*
            //________________________________________________________________________________________________________
            openFileBrowser() {
                var nativeUploadButton = this.$refs.heizungStep1_Input_fileUpload
                console.log(nativeUploadButton)
                nativeUploadButton.click()
            }, //________________________________________________________________________________________________________
            upload_reset() {
                // reset form to initial state
                this.uploadStatus = STATUS_INITIAL
                this.uploadedFiles = []
                this.uploadError = null
                this.showInfoModal = false
                this.upload_progress = 0
                this.upload_errorText = 0
                this.upload_fileSize = 0
            }, //________________________________________________________________________________________________________
            upload_progressUpdater(startTime, fileSize) {
                this.stepper++
                var intervall = 1000
                var durExp = parseInt(fileSize / this.upLoadSpeed * 10) / 10
                var duration = new Date().getTime() - startTime
                var loopNr = duration / intervall
                var uploadedSize = parseInt(this.upLoadSpeed * duration / 1000, 10)
                var percent = parseInt(uploadedSize / fileSize * 100, 10)
                percent = percent > 100 ? 100 : percent
                this.upload_progress = percent

                console.log(this.stepper + ' progress NEU:', loopNr + ')', parseInt(duration / 100) / 10 + 's von ' + durExp + 's |', this.upload_progress + ' % /', uploadedSize + ' B von ', fileSize + ' B')
                if (percent >= 100 || this.stepper > 100) {
                    console.log('STOP INTERVAL TIMER')
                    clearInterval(this.upload_progressIntervallTimer)
                }

            }, //________________________________________________________________________________________________________
            upload_timeTest() {
                var size = 100000
                var startTime = new Date().getTime()
                var testData = String.fromCharCode(65 + Math.floor(Math.random() * Math.floor(24)))
                testData = testData.repeat(size)

                this.$store.dispatch(
                    'sendApiRequest',
                    {
                        sender: 'heizung Rechner  Step I',
                        command: 'fileUpload',
                        files: [],
                        args: {
                            url_param_rechner: this.$route.params.rechnerName,
                            mode: 'speedTest',
                            length: size,
                            testData: testData,
                        },
                        onSuccess: (response) => {
                            this.$nextTick(() => {
                                console.log('timeTest submitted')
                                console.log(response.data)
                                var duration = new Date().getTime() - startTime
                                this.$forceUpdate()
                                this.$nextTick(function () {
                                    this.upLoadSpeed = parseInt(size / duration * 1000 * 1.4, 10)
                                    this.upload_errorText = response.data.error_text
                                    console.log('timeTest -> SUCCESS :', duration, this.upLoadSpeed + ' B/s')
                                    this.$forceUpdate()
                                })

                            })
                        },
                        onError: (response) => {
                            console.log('timeTest NOT sucessed')

                        },
                        onProgress: (event) => {
                            this.upload_progress = parseInt(event.loaded / event.total * 100, 10)
                            console.log('progress: time, percent, current, total', new Date().getTime() - startTime, this.upload_progress, event.loaded, event.total)
                        }
                    }
                )

            }, //________________________________________________________________________________________________________

            upload_save(formData, fileList) {
                this.showInfoModal = true

                // upload data to the server
                this.uploadStatus = STATUS_SAVING

                var startTime = new Date().getTime()

                this.$store.dispatch(
                    'sendApiRequest',
                    {
                        sender: 'RechnerTemplate->created',
                        command: 'fileUpload',
                        files: fileList,
                        args: {
                            url_param_rechner: this.$route.params.rechnerName,
                            fileData2: 'xxx',
                        },
                        onSuccess: (response) => {
                            this.$nextTick(() => {
                                console.log('Antrang submitted')
                                console.log(response.data)
                                if (response.data.status === 'success') {
                                    this.uploadStatus = STATUS_SUCCESS
                                    console.log('file Upload sucessed')
                                    this.value.fieldValues.heizung_upload_filename = response.data.temp_uploaded_files[0]
                                } else {
                                    this.uploadStatus = STATUS_FAILED
                                    this.upload_errorText = response.data.error_text
                                    console.log('file Upload NOT sucessed')
                                }
                            })
                        },
                        onError: (response) => {
                            this.uploadStatus = STATUS_FAILED
                            this.upload_errorText = 'der Server reagiert nicht'
                            console.log('file Upload NOT sucessed')

                        },
                        onProgress: (event) => {
                            //  this.upload_progress = parseInt(event.loaded / event.total * 100, 10)
                            // console.log('progress: percent, current, total', this.upload_progress, event.loaded, event.total)
                        }
                    }
                )
                this.stepper = 0
                console.log('START IntervallTimer ....')
                this.upload_progressIntervallTimer = setInterval(() => this.upload_progressUpdater(startTime, this.upload_fileSize), 250)

            }, //________________________________________________________________________________________________________
            upload_filesChange(fieldName, fileList) {
                // handle file changes
                var formData = new FormData()

                console.log('fieldName', fieldName)
                console.log('fileList', fileList)

                if (!fileList.length) return

                // append the files to FormData
                var size_error = false
                Array
                    .from(Array(fileList.length).keys())
                    .map(x => {
                        var filesize = fileList[x].size
                        this.$forceUpdate()
                        this.$nextTick(function () {
                            this.upload_fileSize = filesize
                            this.$forceUpdate()
                        })

                        if (filesize > 1024000) {
                            size_error = true
                            console.log('file to upload to big !', filesize)
                            this.showInfoModal = true
                            this.uploadStatus = STATUS_FAILED
                            this.upload_errorText = 'Die gewählte Datei ist zu gross (max. 1MB)'
                            console.log('file Upload NOT sucessed')
                        } else {
                            console.log('filesize Okay: ', filesize)
                        }
                        formData.append(fieldName, fileList[x], fileList[x].name)
                    })
                if (size_error) {
                    formData = null

                    return
                } else {
                    this.value.fieldValues.heizung_kaufvertrag_filename = fileList[0].name
                }
                console.log('formData', formData.entries())
                // save it
                this.upload_save(formData, fileList)
            },
            */
            test: function () {
                this.$v.$touch()
                console.log("TEST1")
            },

        },  //===========================================================================================================
        watch: {

            value: {
                handler: function (newVal, oldVal) {
                    console.log('~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~')
                    console.log('WATCHER fieldValues in ', this.$options.label)
                    // var fD = this.fieldDefs
                    var fV = this.value.fieldValues
                    var fVold = this.frmValuesOld
                    var earlyExit = true

                    // console.log('TEST ', fV.heizung_art_pkw_nfz, (fV.heizung_art_pkw_nfz === "PKW") * 1)

                    for (var key in fV) {
                        console.log('Watcher TEST :', key, ":", fV[key], " -> ", fVold[key])
                        if (fV[key] !== fVold[key]) {
                            earlyExit = false
                            this.update_Ort_by_PLZ(key)
                        }
                    }
                    if (earlyExit === true) {
                        console.log('NO changes -> early EXIT')
                        return
                    }
                    console.log('FOUND changes -> check handlers ...')

                    //----------------------------------------------------------------------------
                    // -> hier evtl. Reaktion auf Änderungen von Form-Values
                    /*------------------------------------------------------------------------------------*/


                    if (fV.heiz_kaufpreis != fVold.heiz_kaufpreis) {

                    }

                    //----------------------------------------------------------------------------

                    this.frmValuesOld = _.assign({}, fV)

                },
                deep: true,

            },
        }, //========================================================================================================
        /* ohter components are programmatically setted my step-mixin*/
        components: {},
        //===========================================================================================================
        props: [/* programmatically setted by step-mixin*/],
        //===========================================================================================================
        // HOOKS:
        /* programmatically setted by step-mixin*/
        mounted: function () {
          //  this.upload_reset()
          //  this.upload_timeTest()

        },
        //===========================================================================================================
    }
</script>
<!-- ############################################################################################################################################################# -->
<!-- ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯ -->
<style>

</style>
